import React from 'react'
import { Separator, Skeleton } from '@fs/zion-ui'
import SimpleSkeleton from './SimpleSkeleton'

const path = window.location.pathname || '/'
// main sign up path could be "/identity/signup/" or "{locale}/identity/signup/"
const useSignUpStartSkeleton = path === '/' || path.endsWith('/identity/signup/') || path.endsWith('/register/')

export default function AppSkeleton() {
  return useSignUpStartSkeleton ? <SignUpStartSkeleton /> : <SimpleSkeleton />
}

// Optimize this skeleton for the look and height on desktop so that the background image and scrolling transition is smoothest
function SignUpStartSkeleton() {
  return (
    <>
      {/* Sign up heading  */}
      <Skeleton.H4 subheadingLineCount={1} />
      <Separator size="xs" />
      {/* Explanation  */}
      <Skeleton.Paragraph size="sm" lineCount={2} />
      <Separator size="nano" />
      <Skeleton.Paragraph size="sm" lineCount={3} />
      {/* 4 Social button links */}
      <Separator size="md" />
      <Skeleton.Button minWidth="100%" />
      <Separator size="xs" />
      <Skeleton.Button minWidth="100%" />
      <Separator size="xs" />
      <Skeleton.Button minWidth="100%" />
      <Separator size="xs" />
      <Skeleton.Button minWidth="100%" />
      <Separator size="xs" />
      {/* -- or -- */}
      <Skeleton.H5 centered />
      <Separator size="xs" />
      {/* Create a username and password expand button */}
      <Skeleton.H5 centered />
      <Separator size="xl" />
    </>
  )
}
